export default (selector: string) => {
  const element = document.querySelector(selector) as HTMLElement;

  element.scrollTop = element.scrollHeight;
};
